module.exports = __webpack_public_path__ + "img/max.dbc1f5bb.svg";